import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getApiBaseUrl } from '../config';
import './PasswordGate.css'; // Reuse gate styling or add specific overrides

const SESSION_DURATION_MS = 1 * 60 * 60 * 1000;

function DemoGate({ children }) {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    checkGate();
  }, []);

  const checkGate = async () => {
    // 1. Check if user completed the contact form
    const formSubmitted = localStorage.getItem('contactFormSubmitted') === 'true';
    if (formSubmitted) {
      setIsUnlocked(true);
      setIsLoading(false);
      return;
    }

    // 2. Check if user has active demo password authentication
    const authenticated = localStorage.getItem('demoAuthenticated');
    const authenticatedAt = parseInt(localStorage.getItem('demoAuthenticatedAt') || '0', 10);
    if (authenticated === 'true' && (Date.now() - authenticatedAt) < SESSION_DURATION_MS) {
      setIsUnlocked(true);
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${getApiBaseUrl()}/api/demo-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const data = await response.json();

      if (response.ok && data.success) {
        localStorage.setItem('demoAuthenticated', 'true');
        localStorage.setItem('demoAuthenticatedAt', Date.now().toString());
        setIsUnlocked(true);
        setPassword('');
      } else {
        setError(data.error || 'Incorrect password');
        setPassword('');
      }
    } catch (err) {
      console.error('[DemoGate] Password check error:', err);
      setError('Connection error — please try again');
      setPassword('');
    }
  };

  if (isLoading) return null;

  if (!isUnlocked) {
    return (
      <div className="password-gate">
        <div className="password-gate-container">
          <div className="password-gate-content">
            <h1>Apex Interactive Demo</h1>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-secondary)' }}>
              This demo is locked. Please complete the contact form to request access, or enter your access code below.
            </p>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', alignItems: 'center' }}>
              <Link to="/download" className="cta-button primary" style={{ width: '100%', textDecoration: 'none', textAlign: 'center' }}>
                Complete Contact Form
              </Link>
              
              <div style={{ display: 'flex', alignItems: 'center', width: '100%', margin: '0.5rem 0' }}>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }} />
                <span style={{ padding: '0 10px', fontSize: '0.9rem', color: 'var(--text-muted)' }}>OR</span>
                <hr style={{ flex: 1, border: 'none', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }} />
              </div>

              <form onSubmit={handlePasswordSubmit} style={{ width: '100%', display: 'flex', gap: '0.5rem' }}>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter access code"
                  style={{ flex: 1 }}
                />
                <button type="submit">Unlock</button>
              </form>
            </div>
            {error && <p className="error" style={{ marginTop: '1rem' }}>{error}</p>}
          </div>
        </div>
      </div>
    );
  }

  return children;
}

export default DemoGate;
